export default __webpack_public_path__ + "static/media/215.881d463c.jpg";